import React from 'react';
import { Bell, Check, ExternalLink, Calendar, MessageSquare, Star, Info } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const NotificationCenter = ({ notifications, unreadCount, onMarkAsRead, onMarkAllAsRead, onClose, onNavigate, pushNotifications }) => {
  const getTypeIcon = (type) => {
    switch (type) {
      case 'invitation': return <Calendar size={16} className="text-blue-400" />;
      case 'message': return <MessageSquare size={16} className="text-green-400" />;
      case 'rating': return <Star size={16} className="text-yellow-400" />;
      default: return <Info size={16} className="text-gray-400" />;
    }
  };

  return (
    <div className="notification-dropdown">
      <div style={{
        padding: '16px',
        borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <h3 style={{ margin: 0, fontSize: '1rem', color: '#fff', display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Bell size={18} />
          Notificaciones
          {unreadCount > 0 && (
            <span style={{ 
              background: '#ff4444', 
              color: '#fff', 
              fontSize: '0.7rem', 
              padding: '2px 6px', 
              borderRadius: '10px' 
            }}>
              {unreadCount}
            </span>
          )}
        </h3>
        <button 
          onClick={onClose}
          style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.5)', cursor: 'pointer' }}
        >
          Cerrar
        </button>
      </div>

      <div style={{ overflowY: 'auto', flex: 1 }}>
        {notifications.length === 0 ? (
          <div style={{ padding: '40px 20px', textAlign: 'center', color: 'rgba(255,255,255,0.4)' }}>
            <Bell size={32} style={{ marginBottom: '12px', opacity: 0.2 }} />
            <p>No tienes notificaciones aún.</p>
          </div>
        ) : (
          notifications.map((n) => (
            <div 
              key={n.id}
              onClick={() => {
                if (!n.is_read) onMarkAsRead(n.id);
                if (n.url) {
                  if (onNavigate) {
                    onNavigate(n.url);
                    onClose();
                  } else {
                    window.location.href = n.url;
                  }
                }
              }}
              style={{
                padding: '12px 16px',
                borderBottom: '1px solid rgba(255, 255, 255, 0.05)',
                cursor: 'pointer',
                background: n.is_read ? 'transparent' : 'rgba(255, 255, 255, 0.05)',
                transition: 'background 0.2s',
                position: 'relative'
              }}
            >
              {!n.is_read && (
                <div style={{ 
                  position: 'absolute', 
                  left: '4px', 
                  top: '50%', 
                  transform: 'translateY(-50%)',
                  width: '4px',
                  height: '4px',
                  borderRadius: '50%',
                  background: '#3b82f6'
                }} />
              )}
              <div style={{ display: 'flex', gap: '12px' }}>
                <div style={{ marginTop: '2px' }}>{getTypeIcon(n.type)}</div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: '0.85rem', fontWeight: n.is_read ? '500' : '700', color: '#fff', marginBottom: '2px' }}>
                    {n.title}
                  </div>
                  <div style={{ fontSize: '0.75rem', color: 'rgba(255,255,255,0.6)', lineHeight: '1.2' }}>
                    {n.body}
                  </div>
                  <div style={{ fontSize: '0.65rem', color: 'rgba(255,255,255,0.3)', marginTop: '6px' }}>
                    {new Date(n.created_at).toLocaleDateString()} {new Date(n.created_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>

      <div style={{
        padding: '12px',
        textAlign: 'center',
        background: 'rgba(0,0,0,0.2)',
        borderTop: '1px solid rgba(255, 255, 255, 0.1)'
      }}>
        <button 
          style={{ 
            background: 'none', 
            border: 'none', 
            color: '#3b82f6', 
            fontSize: '0.75rem', 
            cursor: 'pointer',
            fontWeight: '600'
          }}
          onClick={onMarkAllAsRead}
        >
          Marcar todas como leídas
        </button>

        {/* Push Notification Shortcut */}
        <div style={{ 
          marginTop: '12px', 
          paddingTop: '12px', 
          borderTop: '1px solid rgba(255,255,255,0.05)',
          display: 'flex',
          flexDirection: 'column',
          gap: '8px'
        }}>
          {!pushNotifications?.isSubscribed ? (
            <button 
              onClick={() => {
                onNavigate('/profile');
                onClose();
              }}
              className="glass"
              style={{ 
                width: '100%', 
                padding: '8px', 
                fontSize: '0.7rem', 
                color: 'var(--primary)',
                border: '1px dashed var(--primary)',
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '6px',
                cursor: 'pointer'
              }}
            >
              <Bell size={14} />
              Configurar alertas en el celular
            </button>
          ) : (
            <div style={{ fontSize: '0.65rem', color: 'rgba(255,255,255,0.3)', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px' }}>
              <Check size={12} color="#44ff44" />
              Alertas en el celular activas
            </div>
          )}
        </div>
      </div>
    </div>

  );
};

export default NotificationCenter;
